import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "password-input" }
const _hoisted_2 = { class: "password-input__container" }
const _hoisted_3 = ["type", "id", "placeholder", "autocomplete"]
const _hoisted_4 = { class: "password-input__check-list" }

import { computed, reactive, ref } from "vue";
import KasaIcon from "@/components/shared/assets/kasa-icon.vue";
import AccountInput from "./account-input.vue";

/* eslint-disable @typescript-eslint/naming-convention */

export default /*@__PURE__*/_defineComponent({
  __name: 'new-password-input',
  props: /*@__PURE__*/_mergeModels({
    modelValue: {},
    name: {},
    dataLayerErrorLogger: { type: Function },
    placeholder: {},
    autocompleteOff: { type: Boolean },
    hideTitle: { type: Boolean }
  }, {
    "errorMessage": {},
    "errorMessageModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue", "inputErrorDetected"], ["update:errorMessage"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const props = __props;

const errorMessage = _useModel<string>(__props, "errorMessage");

const passwordValue = computed({
    get() {
        return props.modelValue;
    },
    set(passwordValue) {
        errorMessage.value = null;
        emit("update:modelValue", passwordValue);
    },
});

const eyeActive = ref(false);
const showPassword = async () => {
    eyeActive.value = !eyeActive.value;
};

const inputType = computed(() => (eyeActive.value ? "text" : "password"));

const checkPasswordSpecialCharacters = () => /\W+/.test(passwordValue.value);
const checkPasswordNumberLetter = () => /\d+/.test(passwordValue.value) && /[A-Za-z]+/.test(passwordValue.value);
const checkPasswordLength = () => passwordValue.value.length >= 6;

const checkList = reactive({
    specialCharacters: true,
    number: false,
    length: false,
});

const isNewPasswordValid = computed(() => checkList.specialCharacters && checkList.number && checkList.length);

const validPassword = () => {
    checkList.specialCharacters = !checkPasswordSpecialCharacters();
    checkList.number = checkPasswordNumberLetter();
    checkList.length = checkPasswordLength();

    return isNewPasswordValid.value;
};

const checkIfIsValid = (silentCheck?: boolean): boolean => {
    let isValid = true;

    if (!passwordValue.value) {
        if (!silentCheck) {
            errorMessage.value = "Nastavte si vaše heslo.";
        }
        isValid = false;
    } else if (!isNewPasswordValid.value) {
        if (!silentCheck) {
            errorMessage.value = "Heslo není validní.";
        }
        isValid = false;
    }

    return isValid;
};

__expose({
    checkIfIsValid,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AccountInput, {
      errorMessage: errorMessage.value,
      title: _ctx.hideTitle ? null : 'Vytvořte heslo',
      name: _ctx.name,
      onInputErrorDetected: _cache[1] || (_cache[1] = ($event: any) => (emit('inputErrorDetected', _ctx.name, errorMessage.value)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: inputType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((passwordValue).value = $event)),
            id: _ctx.name,
            onKeyup: validPassword,
            placeholder: _ctx.placeholder,
            autocomplete: _ctx.autocompleteOff ? 'off' : null
          }, null, 40, _hoisted_3), [
            [_vModelDynamic, passwordValue.value]
          ]),
          _createVNode(KasaIcon, {
            name: "eye",
            width: 20,
            height: 20,
            class: "password-input__input-icon",
            onClick: showPassword
          })
        ])
      ]),
      _: 1
    }, 8, ["errorMessage", "title", "name"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["password-input__check", { checked: checkList.specialCharacters }])
      }, " Nesmí obsahovat diakritiku či speciální znaky ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["password-input__check", { checked: checkList.number }])
      }, " Musí obsahovat alespoň 1 číslici a písmeno. ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["password-input__check", { checked: checkList.length }])
      }, " Musí mít délku alespoň 6 znaků. ", 2)
    ])
  ]))
}
}

})